<div mat-dialog-title>
    <div class="d-flex justify-content-between">
        <p>Bulk DTN</p>
        <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
    </div>
</div>
<div mat-dialog-content>
    <br />
    <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen}">
        <!-- [pageable]="true" [pageSize]="20" -->
        <kendo-grid [kendoGridBinding]="gridData" [height]="750" id="respondWorflowLandingGrid" [sortable]="true" [resizable]="true" [reorderable]="true" [filterable]="enableFilter" [selectable]="true" [scrollable]="true" (mouseover)="onHover($event)" class="form-group-grid auto-complete-equal kg-hover-icon" (selectionChange)="onSelectionChange($event)" (edit)="editRowData($event)" (cancel)="cancelRowData($event)" (save)="UpdateRowData($event)">
            <ng-template kendoPagerTemplate>
                <div class="k-pager-left">
                    <kendo-pager-info></kendo-pager-info>
                </div>
                <div class="k-pager-right">
                    <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                    <kendo-pager-input></kendo-pager-input>
                    <kendo-pager-next-buttons></kendo-pager-next-buttons>
                </div>
            </ng-template>
            <kendo-grid-checkbox-column showSelectAll="true" width="30"></kendo-grid-checkbox-column>
            <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                    {{rowIndex+1}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="documentId" title="DRG/Document Id" width="10" hidden="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.documentId}}" eipTooltipPosition="auto">
                        {{dataItem.documentId}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="documentNumber" title="Document Number" width="150">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                    <span class="no-wrap" eipTooltip="{{dataItem.documentNumber}}" eipTooltipPosition="auto">
                        {{dataItem.documentNumber}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="documentTitle" title="Title" width="150">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                    <span class="no-wrap" eipTooltip="{{dataItem.documentTitle}}" eipTooltipPosition="auto">
                        {{dataItem.documentTitle}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="revisionNo" title="Revision" width="70">
                <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                    <span class="">
                        {{dataItem.revisionNo}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="workflowDescription" title="Workflow" width="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.workflowDescription}}" eipTooltipPosition="auto">
                        {{dataItem.workflowDescription}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="taskId" title="Task Id" width="10" hidden="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.taskId}}" eipTooltipPosition="auto">
                        {{dataItem.taskId}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="taskStage" title="Workflow Stage" width="100" id="GrlblStage">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.subWorkflowName}}" eipTooltipPosition="auto">
                        {{dataItem.subWorkflowName}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="taskName" title="Workflow Task" width="150" id="GrlblStatus">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.taskName}}" eipTooltipPosition="auto">
                        {{dataItem.taskName}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="assignedToId" title="Assigned To Id" width="10" hidden="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.assignedToId}}" eipTooltipPosition="auto">
                        {{dataItem.assignedToId}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="assignedToName" title="Assigned To" width="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span class="no-wrap" eipTooltip="{{dataItem.assignedToName}}" eipTooltipPosition="auto">
                        {{dataItem.assignedToName}}</span>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</div>
<div mat-dialog-actions>
    <div class="row justify-content-end flex-grow-1">
        <button class="btn btn-primary eip-ml-10 mr-10 eip-mt-10" id="btnDTNPrepare" [disabled]="!isEnable()" (click)="dtnPreparation()"><i class="fa fa-arrow-circle-right" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Prepare DTN</button>
    </div>
</div>